export type ContestEntryApplicantFormValue = {
  name: string;
  nameKana: string;
  penname: string;
  email: string;
  phone: string;
  gender: number;
  birthDate: string;
  historyOfAwards: string;
};

export type UpdateApplicantFormFieldFn = <K extends keyof ContestEntryApplicantFormValue>(
  field: K,
  fieldValue: ContestEntryApplicantFormValue[K],
) => void;

function readInputValue(event: Event): string {
  if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
    return event.target.value;
  }
  return "";
}

function readSelectValue(event: Event): string {
  if (event.target instanceof HTMLSelectElement) {
    return event.target.value;
  }
  return "";
}

export function createContestEntryApplicantInfoFormEventHandlers(updateField: UpdateApplicantFormFieldFn) {
  return {
    onNameInput: (event: Event) => updateField("name", readInputValue(event)),
    onNameKanaInput: (event: Event) => updateField("nameKana", readInputValue(event)),
    onPennameChange: (event: Event) => updateField("penname", readSelectValue(event)),
    onEmailInput: (event: Event) => updateField("email", readInputValue(event)),
    onPhoneInput: (event: Event) => updateField("phone", readInputValue(event)),
    onBirthDateInput: (event: Event) => updateField("birthDate", readInputValue(event)),
    onHistoryOfAwardsInput: (event: Event) => updateField("historyOfAwards", readInputValue(event)),
  };
}
